import axios, { AxiosPromise, CancelTokenSource } from 'axios';
import httpClient from '../../common/api/httpClient';
import urlRoute from '../../common/service/urlRoute';
import IVariantDetails from '../model/IVariantDetails';
import IProductVariantList from '../model/IProductVariantList';
import { API } from '../constants/api';
import IVariantSpecifications from '../model/IVariantSpecifications';

let detailsSource: CancelTokenSource;

const variantsApi = {
  list: (modelId: string): AxiosPromise<IProductVariantList> => {
    return httpClient.get(urlRoute.createUrl(API.VARIANTS_PATH, { modelId }));
  },
  details: (variantId: string, cancelPrevious = false): AxiosPromise<IVariantDetails> => {
    if (cancelPrevious && detailsSource) {
      detailsSource.cancel();
    }

    detailsSource = axios.CancelToken.source();

    return httpClient.get(
      urlRoute.createUrl(API.VARIANT_DETAILS_PATH, {
        variantId,
      }),
      {},
      { cancelToken: detailsSource.token },
    );
  },
  specifications: (variantId: string): AxiosPromise<IVariantSpecifications> => {
    return httpClient.get(urlRoute.createUrl(API.VARIANT_SPECIFICATIONS_PATH, { variantId }));
  },
};

export default variantsApi;
